import ready from "./ready"
import Trigger from "../classes/Trigger"

var navbar: HTMLElement

ready(async () => {
   navbar = document.querySelector('header.navbar')!

   if (!navbar) return
   new Trigger('scroll', () => {
      (window.scrollY ?? document.documentElement.scrollTop) > (navbar?.clientHeight ?? 0) / 2
         ? navbar?.classList.add('minified')
         : navbar?.classList.remove('minified')
   }, 'window')

   new Trigger('click', (e: Event) => {
      (e.currentTarget as HTMLElement).classList.toggle('open')
   }, () => navbar?.querySelector('.navbar-toggler')!)
})
